module.exports = __webpack_public_path__ + "img/advantage4_1@2x.13c135c9.png";